import toast from 'react-hot-toast';

type ErrorWithResponse = {
  message?: string;
  response?: {
    data?: {
      message?: string;
      error?: string;
    } | string;
  };
};

export const getErrorMessage = (error: unknown, fallback = 'Something went wrong'): string => {
  if (typeof error === 'string' && error.trim()) return error;

  const typedError = error as ErrorWithResponse;
  const responseData = typedError?.response?.data;

  if (typeof responseData === 'string' && responseData.trim()) return responseData;
  if (responseData && typeof responseData === 'object') {
    if (responseData.message) return responseData.message;
    if (responseData.error) return responseData.error;
  }
  if (typedError?.message) return typedError.message;

  return fallback;
};

export const showErrorToast = (error: unknown, fallback?: string) => {
  toast.error(getErrorMessage(error, fallback));
};

export const showSuccessToast = (message: string) => {
  toast.success(message);
};
